import React from "react";
import { track } from "@flights/et-universal";
import { FlightDetailsGeniusBenefitsDesktopUI } from "../../../../../../ui/FlightDetails/FlightDetailsGeniusBenefits.desktop.ui.js";
import useGeniusRewardsInfo from "./useGeniusRewardsInfo.js";
import { useI18n, t } from "@bookingcom/lingojs-react";
export function GeniusRewardsInfoDesktop(props) {
    const { flight } = props;
    const i18n = useI18n();
    const geniusRewards = useGeniusRewardsInfo(flight);
    const { header, footer, content } = geniusRewards || {};
    if ((typeof content !== "string" && !Array.isArray(content)) ||
        typeof header !== "string" ||
        typeof footer !== "string")
        return null;
    if (typeof header !== "string")
        return null;
    return (React.createElement(FlightDetailsGeniusBenefitsDesktopUI, { header: header, footer: footer, benefits: typeof content === "string" ? [content] : content, geniusImgAlt: i18n.trans(t("a11y_flights_mdot_fd_genius_logo")), headerWithIcon: track("flights_funnel_new_fd_page_desktop") === 1 }));
}
